import { useEffect, useMemo, useState } from "react";
import AuiButton from "../Buttons/Buttons";
import DropDown from "../DropDown/DropDown";
import {
  getOrganisationList,
  OrganisationListParams,
} from "../../services/training-session.service";
import { useDispatch } from "react-redux";
import { showAlert } from "../../store/alertSlice";
import SearchableSingleSelectDropdown from "../DynamicDropdowns/SearchableSingleSelectDropdown";
import { useDebouncedSearch } from "../../utils/constants/app-constants";
import { mergeSelectedWithList } from "../Hooks/classDetailMultiDropdownHook";

export interface DropdownOption {
  id: number;
  name: string;
}

interface FilterProps {
  setCertType: (orgType: DropdownOption | null) => void;
  setOrgName: (orgName: DropdownOption | null) => void;
  setCurrentPage: (page: number) => void;
}

const CertificateFilterSection: React.FC<FilterProps> = ({
  setCertType,
  setOrgName,
  setCurrentPage,
}) => {
  const certificateType: DropdownOption[] = [
    { id: 1, name: "Attendance" },
    { id: 2, name: "Completion" },
  ];

  const [orgNames, setOrgNames] = useState<DropdownOption[]>([]);
  const [selectecertType, setSelectecertType] = useState<DropdownOption | null>(
    null
  );
  const [selectedOrgName, setSelectedOrgName] = useState<DropdownOption | null>(
    null
  );
  const [isDataLoading, setIsDataLoading] = useState(true);
  const dispatch = useDispatch();

  const mergedCountryList = useMemo(
        () => mergeSelectedWithList(orgNames, selectedOrgName, "id"),
        [orgNames, selectedOrgName]
      );
      
  const fetchDropdownData = async (search = "") => {
    try {
      setIsDataLoading(true);
      const orderBy = "ASC";
      const sortBy = "name";
      const params: OrganisationListParams = {
        pageSize: 50,
        name: search,
        sortBy,
        orderBy,
      };

      const result = await getOrganisationList(params);
      if (!result || result.status !== 200) {
        dispatch(
          showAlert({
            message: "Failed to fetch organisation list",
            type: "error",
          })
        );
      } else {
        const organisations = result?.data?.organisations || [];
        
        setOrgNames(organisations);
      }
    } catch (error) {
        console.error("Error fetching dropdown data:", error);
      } finally {
        setIsDataLoading(false);
      }
    };

  const debouncedSearchOrganization = useDebouncedSearch(fetchDropdownData);

  useEffect(() => {
    fetchDropdownData();
  }, []);

  const handleSelectionChange = (
    value: string,
    options: DropdownOption[],
    setSelected: React.Dispatch<React.SetStateAction<DropdownOption | null>>
  ) => {
    const selectedOption = options.find((option) => option.name === value);
    setSelected(selectedOption || null);
  };

  const handleGoClick = () => {
    setCertType(selectecertType);
    setOrgName(selectedOrgName);
    setCurrentPage(1);
  };

  return (
    <div className="filter-section my-4">
      <div className="dropdown-container">
        <div className="container">
          <div className="row align-items-end">
            <div className="col-12 col-md-10 col-lg-11 classtypeFilter">
              <div className="row align-items-end">
                <div className={"col-12  col-md-6"}>
                  <DropDown
                    listInBtn
                    data={certificateType.map((org) => org.name)}
                    dropdownLabel="Type"
                    placeHolder="All Certificates"
                    mainId="Type"
                    onChange={(value) =>
                      handleSelectionChange(
                        value,
                        certificateType,
                        setSelectecertType
                      )
                    }
                  />
                </div>
                <div className={"col-12  col-md-6"}>
                  <SearchableSingleSelectDropdown
                    listInBtn
                    data={mergedCountryList.map((org) => org.name)}
                    dropdownLabel="Organisation"
                    placeHolder="All Organisations"
                    mainId="Organisation"
                    data-testid="org-filter-id"
                    isLoading={isDataLoading}
                    onChange={(value) =>
                      handleSelectionChange(
                        value,
                        mergedCountryList,
                        setSelectedOrgName
                      )
                    }
                    onSearch={debouncedSearchOrganization}
                    value={selectedOrgName?.name ?? ""}
                    dropId="All Organisations"
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-2 col-lg-1">
              <div className="row justify-content-end align-items-end btnGo py-3 py-md-0 pr-3 pr-md-2">
                <AuiButton
                  variant="primary"
                  buttontitle="Go"
                  buttonid="filterOrg"
                  size="medium"
                  buttonClick={handleGoClick}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificateFilterSection;
